import { PropTypes } from 'prop-types';

import './index.less';

function ContentBox({ icon, image, children }) {
  return (
    <div className="content-box">
      {(icon || image) && (
        <div className="content-box__header">
          {image && (
            <div className="content-box__header__wrapper">
              <img src={image} className="content-box__header__wrapper--image" />
            </div>
          )}
          {icon && <div className="content-box__header--icon"> {icon} </div>}
        </div>
      )}
      <div className="content-box__body">{children}</div>
    </div>
  );
}

ContentBox.propTypes = {
  icon: PropTypes.node,
  image: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default ContentBox;
